import React from 'react';
import { Paper, Text, Group, Box } from '@mantine/core';
import clsx from 'clsx';
import { useLocalizedDate } from '../../../hooks/useLocalizedDate';
import { formatFileSize } from '../../../utils/fileValidation';
import { FileTypeIcon } from '../FileTypeIcon';
import { ICON_SIZE_SM } from '../../../constants/ui';
import styles from './AttachmentRow.module.css';
import type { AttachmentRowProps } from './AttachmentRow.types';

export const AttachmentRow = ({
  name,
  size,
  date,
  mimeType,
  actions,
  className,
  onClick,
}: AttachmentRowProps) => {
  const { formatDateCompact } = useLocalizedDate();

  return (
    <Paper
      p="sm"
      withBorder
      className={clsx(styles.root, onClick && styles.clickable, className)}
      onClick={onClick}
      {...(onClick && {
        role: 'button',
        tabIndex: 0,
        onKeyDown: (e: React.KeyboardEvent) => {
          if (e.key === 'Enter' || e.key === ' ') {
            e.preventDefault();
            onClick();
          }
        },
      })}
    >
      <Group justify="space-between" align="center">
        <Group gap="sm" className={styles.flexContent}>
          <FileTypeIcon name={name} mimeType={mimeType} size={ICON_SIZE_SM} />
          <Box className={styles.flexContent}>
            <Text size="sm" lineClamp={1}>
              {name}
            </Text>
            <Text size="xs" c="dimmed">
              {formatFileSize(size)} • {formatDateCompact(date)}
            </Text>
          </Box>
        </Group>

        {actions && (
          <div className={styles.actions} onClick={(e) => e.stopPropagation()}>
            {actions}
          </div>
        )}
      </Group>
    </Paper>
  );
};
